import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'

import '../css/logosection.css'

export default class LogoSection extends Component {
	showSidebar(){
		if(	document.getElementsByClassName('sidebar')[0].style.display
			=== 'block') {
				document.getElementsByClassName('sidebar')[0].style.display = 'none';
				document.getElementsByClassName('menu-mobile')[0].style.filter = 'none';
		} else {
			document.getElementsByClassName('sidebar')[0].style.display = 'block';
			document.getElementsByClassName('menu-mobile')[0].style.filter = 'brightness(0) invert(1)';
		}
	}
	
	render() {
		return (
		<div id="logosection" className="logosection">
			<div className="logoRMP">
				<img 
					src="./img/resources/LOGO-RMP-OPERA.png"
					className="hover_brillo"
					alt='logo RMP'
				/>
			</div>
			<div className="menu-mobile">
				<img 
					src="./img/resources/BOTON-MENU.png"
					alt='menu'
					onClick={this.showSidebar}
				/>
			</div>
			<div className="medallaRMP">
				<img 
					src="./img/resources/MEDALLA-MARTILLO.png"
					alt='medalla'
				/>
			</div>
		</div>
	)}
}


// WEBPACK FOOTER //
// ./src/components/logosection.js